import { Dispatch } from 'redux';

import {
  SET_PAGE,
  SET_START,
  SET_SORT,
  RESET_SEARCH_PARAMS,
  SET_FILTER,
  SET_STATUS,
  ListingSearchActionTypes,
  SET_HEADER_SEARCH,
} from './types';
import { HeaderSearch, SortColumns } from 'shared/interfaces';
import { Filters } from 'shared/types';

const setListingsPage = (page: number): ListingSearchActionTypes => {
  return {
    type: SET_PAGE,
    page,
  };
};

const setListingsStart = (start: number): ListingSearchActionTypes => {
  return {
    type: SET_START,
    start,
  };
};

export const setListingsFilter = (
  filter: Filters
): ListingSearchActionTypes => {
  return {
    type: SET_FILTER,
    filter,
  };
};

export const setListingsStatus = (
  status: string | null
): ListingSearchActionTypes => {
  return {
    type: SET_STATUS,
    status,
  };
};

export const resetSearchParams = (): ListingSearchActionTypes => {
  return {
    type: RESET_SEARCH_PARAMS,
  };
};

export const setListingsSort = (
  sort: SortColumns
): ListingSearchActionTypes => {
  return {
    type: SET_SORT,
    sort,
  };
};

export const setHeaderSearch = (
  search: HeaderSearch
): ListingSearchActionTypes => {
  return {
    type: SET_HEADER_SEARCH,
    search,
  };
};

export const getListingsPage = (page: number, pageSize: number | undefined) => {
  return (dispatch: Dispatch) => {
    const start = pageSize ? (page - 1) * pageSize : page - 1;
    dispatch(setListingsStart(start));
    dispatch(setListingsPage(page));
  };
};
